import React , {useEffect, useState, useCallback } from "react";
import MetaTags from "react-meta-tags";

import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Table,
} from "reactstrap";



// Redux
import { connect, useDispatch} from "react-redux";
import { withRouter, Link,  useParams} from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";

import Loader from "../../components/Common/Loader";

//Action

import {  casosLista } from "../../store/casos/actions";
import { getInformesPorCasoFilter } from "../../helpers/backend";


const Informe = (props) => {
  const dispatch= useDispatch();
  const user = JSON.parse(localStorage.getItem("user"))
  const groups =String(user.groups);
  const param = useParams();
  const str = param.id; 
  const casosId = Number(str)
  
  const URL = process.env.REACT_APP_API_URL.split("/api").join("");
  const handlePDFClick = (id) => {
    // Redirigir a la URL externa
    window.open(`${URL}/reportes/informe_pdf/${id}/`, '_blank');
  };
  const [InformData, setInformData] = useState(null)
  const getInformData = useCallback(async () => {
    try {
      const response = await getInformesPorCasoFilter(casosId);
      setInformData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [casosId]);
  
  useEffect(() => {
   
    if (casosId) {
      getInformData();
    }
  }, [dispatch, getInformData, casosId]);

console.log(InformData)
 





const handleClick = () => {
  dispatch(casosLista());
}


    return ( 
      <React.Fragment>
        <div className="page-content">

        
         <MetaTags>
         <title> Informes</title>
         </MetaTags>
         <Container fluid>
              <Breadcrumb  breadcrumbItem={"Informes"} />
              {props.loading ? (
          <Loader />
        ) : (
          <div>  
            <h1>Visitas Tecnicas</h1>
            <Card >
              <CardBody>
                <Row>

                <Col md={7}>
                  { groups ==='SuperAdmin'? (

                 <Link
                      className="btn btn-primary waves-effect waves-light"
                      to={`/Informes/${casosId}/add_informe`}
                      onClick={handleClick}
                    >
                       Agregar Visita Tecnica{" "}
                      <span className="bx bx-user-plus fa-lg align-middle"></span>
                  </Link>
                  ):null}
                  
                  <Link
                      className="btn btn-primary waves-effect waves-light m-1"
                      to={`/casos/${casosId}/edit_caso`}
                    >
                       Volver a Caso
                  </Link>
                  </Col>
                  </Row>
              </CardBody>
           </Card>
           <Table
                        className="table table-bordered table-striped text-center mb-3"
                        hover
                      >
                      <thead>
                          <tr>
                            <th>Caso</th>
                            <th>Fecha</th>

                            
                            <th>Informe Visita</th>
                            
                            <th>PDF</th>
                         
                          </tr>
                      </thead>
                      <tbody>
                      {InformData && InformData.length > 0 ? (
  InformData.map((informe) => (
    <tr key={informe.id}>
      <th>
        <Link to={`/informes/${informe.id}/ver_informe`}>
          {casosId}
        </Link>
      </th>
      <th>{informe.created_date}</th>
      <th>{informe.informe_visita}</th>
      <th>
                <button 
                  onClick={() => handlePDFClick(informe.id)}
                  className="btn btn-link"
                >
                  <i className="fas fa-file-pdf" style={{ color: "red", fontSize: "1.5em" }}></i>
                </button>
              </th>
    </tr>
  ))
) : (
  <tr>
    <td colSpan="3">No hay datos disponibles</td>
  </tr>
)}

                      </tbody>
            
            </Table>
          
           
            </div>
              

                 )}
         </Container>
         </div>
        </React.Fragment>
     );
}

const mapStateToProps = (state) => {
  const { error, loading, informes } = state.Informes;
  return { error, loading, informes };
};
 



export default withRouter(connect(mapStateToProps)(Informe));